import { render, staticRenderFns } from "./MyColorPicker3.vue?vue&type=template&id=040213a0&scoped=true&"
import script from "./MyColorPicker3.vue?vue&type=script&lang=js&"
export * from "./MyColorPicker3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040213a0",
  null
  
)

export default component.exports